/** Shortest evolve arrow (normalized evolution): anything shorter is not a movement. */
export const MIN_EVOLVE_DELTA = 0.005;
